import {CONFIG} from "./constants";
import {Meeting} from './MeetingPage/Meeting.tsx'


export function App() {

  let userName: string|null = null;
  let userId: string|null = null;
  let who: string = 'external';
  let meetingKey: string|null = null;
  let meetingType = "coaching";
  let back: string|null = null;

  const readParameters = () => {
      if (window.location.search.indexOf('?') !== -1) {
        let search = window.location.search.substring(1)
        for (const nameValue of search.split('&')) {
          const pair = nameValue.split('=')
          const name: string = pair[0]
          let value = decodeURIComponent(pair[1])
          value = value.replace(/\+/g, ' ')
          if (name === 'name') {
            userName = value
            window.localStorage[CONFIG.USERNAME_TOKEN] = value
          } else if (name === 'token') {
            window.localStorage[CONFIG.PERSON_TOKEN] = value
          } else if (name === 'meetingKey') {
            meetingKey = value
            window.localStorage[CONFIG.MEETING_KEY] = value
          } else if (name === 'meetingType') {
            meetingType = value
          } else if (name === 'who') {
            if (value === 'client' || value === 'coach' || who === 'external') {
              who = value
              window.localStorage[CONFIG.MEETING_WHO] = value
            }
          } else if (name === 'userId') {
            userId = value
            window.localStorage[CONFIG.MEETING_USER_ID] = value
          } else if (name === 'back') {
            back = value
            window.localStorage[CONFIG.MEETING_BACK] = value
          }
          console.log(name + ' = ' + value)
        }
        window.localStorage[CONFIG.MEETING_TYPE] = meetingType;
        history.pushState(null, '', '/');
      } else {
        userName = window.localStorage[CONFIG.USERNAME_TOKEN]
        userId = window.localStorage[CONFIG.MEETING_USER_ID]
        meetingType = window.localStorage[CONFIG.MEETING_TYPE]
        meetingKey = window.localStorage[CONFIG.MEETING_KEY]
        back = window.localStorage[CONFIG.MEETING_BACK]
        let _who = window.localStorage[CONFIG.MEETING_WHO]
        if (who === 'client' || who === 'coach' || who === 'external') {
          who = _who
        }
      }
  }

  readParameters()

  if (userName && userId && who && meetingKey) {
    return (
      <Meeting who={who} userId={userId} userName={userName} meetingKey={meetingKey}
               meetingType={meetingType} back={back}/>
    );
  } else {
    return (
      <div className="mt-4 text-center">
        Missing parameters for video
      </div>
    )
  }

}
